function fmtNum(n) {
  if (n == null) return '0';
  if (Number.isNaN(Number(n))) return String(n);
  const num = Number(n);

  if (num < 1000) return String(num);

  // Pass `undefined` as the locale so Intl uses the user's browser/runtime
  // locale, respecting their language settings (e.g. "1,2K" vs "1.2K").
  return new Intl.NumberFormat(undefined, {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(num);
}

export default fmtNum;
